import { translate } from './translate'

let TWORK_SETTINGS = {}
let TWORK_INFO = {}

// Function to initialize TWORK_SETTINGS after ensuring `window.vueAppConfig` is available
export function initializeSettings () {
  TWORK_SETTINGS = window.vueAppConfig?.settings || {}
  TWORK_INFO = window.vueAppConfig?.info || {}
   //console.log('TWORK_SETTINGS', TWORK_SETTINGS) 
  //console.log('TWORK_INFO', TWORK_INFO)
}
export { TWORK_SETTINGS, TWORK_INFO }
// Change DEFAULT_EVENT_TYPE to a function that returns the default event type object
function getDefaultEventType () {
  return {
    type: 'default',
    id: false,
    path: '',
    name: TWORK_SETTINGS.seo?.title ?? translate('events_all_tab_name'),
    plural: translate('events_all_tab_plural'),
    accusative: translate('events_all_tab_accusative'),
    vocative: '',
    wthis: '',
    wthis2: '',
    wthis3: '',
    excerpt: TWORK_SETTINGS.excerpt || false,
    seo: TWORK_SETTINGS.seo || false,
    images: TWORK_SETTINGS.images || false,
    color: TWORK_SETTINGS.color || 'teal',
    enable_hero: TWORK_SETTINGS.enable_hero || false,
    categories: TWORK_SETTINGS.categories || false,
    hero: {
      title: TWORK_SETTINGS.hero?.title || false,
      subtitle: TWORK_SETTINGS.hero?.subtitle || false,
      image: TWORK_SETTINGS.hero?.image || false,
      video: TWORK_SETTINGS.hero?.video || false,
      buttons: TWORK_SETTINGS.hero?.buttons || false
    }
  }
}

export function formatLocalizedDate (dateString) {
  const date = new Date(dateString)
  const day = date.getDate()
  const month = date.toLocaleString('cs-CZ', { month: 'long' })

  return `${day}. ${translate(month)}`
}

export function getEventTypes () {
  const typesFromConfig = TWORK_SETTINGS.types || []

  const mappedTypes = typesFromConfig.map(type => ({
    type: type.type,
    id: type.id || false,
    path: type.path || '',
    name: type.name || '',
    plural: type.plural || '',
    accusative: type.accusative || '',
    vocative: type.vocative || '',
    wthis: type.wthis || '',
    wthis2: type.wthis2 || '',
    wthis3: type.wthis3 || '',
    excerpt: type.excerpt || false,
    seo: type.seo || false,
    images: type.images || false,
    color: type.color || TWORK_SETTINGS.color,
    enable_hero: type.enable_hero || false,
    categories: type.categories || false,
    hero: {
      title: type.hero?.title || false,
      subtitle: type.hero?.subtitle || false,
      image: type.hero?.image || false,
      video: type.hero?.video || false,
      buttons: type.hero?.buttons || false
    }
  }))

  if (mappedTypes.length !== 1) {
    // Ensure the default event type is always present if there is more than one type
    if (!mappedTypes.find(type => type.type === 'default')) {
      mappedTypes.unshift(getDefaultEventType())
    }
  }

  return mappedTypes
}

export function getEventType (type) {
  const eventTypes = getEventTypes()
  const foundEventType = eventTypes.find(
    eventType => eventType.type === type || eventType.path === type
  )

  return foundEventType || getDefaultEventType()
}
export function generateResultsMessage (totalItems, category, searchInput) {
  // Handle case when totalItems is 0 and display appropriate message
  if (totalItems === 0) {
    if (category && searchInput) {
      return translate('no_results_for_category_search', [
        category.name,
        searchInput
      ])
    } else if (category) {
      return translate('no_results_for_category', [category.name])
    } else if (searchInput) {
      return translate('no_results_for_search', [searchInput])
    } else {
      return translate('no_results_found')
    }
  }

  // Determine the correct pluralization form for non-zero results
  let resultKey = totalItems === 1 ? 'result' : 'results' // Basic pluralization
  if (totalItems > 1 && totalItems < 5) {
    resultKey = 'few_results' // For cases like 2, 3, 4 in Czech
  } else if (totalItems >= 5) {
    resultKey = 'many_results' // For cases like 5+ in Czech
  }

  const resultsText = translate(resultKey, totalItems) // Pass totalItems for context-sensitive translation

  // Handle formatted messages when totalItems > 0
  if (category && searchInput) {
    return translate('%s %s for category „%s“ which contain „%s“', [
      totalItems,
      resultsText,
      category.name,
      searchInput
    ])
  } else if (category) {
    return translate('%s %s for category „%s“', [
      totalItems,
      resultsText,
      category.name
    ])
  } else if (searchInput) {
    return translate('%s %s for search term „%s“', [
      totalItems,
      resultsText,
      searchInput
    ])
  } else {
    return translate('%s %s found', [totalItems, resultsText])
  }
}
export function getUrlParameter (name) {
  const query = new URLSearchParams(window.location.search)
  const paramValue = query.get(name)

  if (paramValue) {
    query.delete(name)
    const newUrl = `${window.location.pathname}?${query.toString()}`
    window.history.replaceState({}, document.title, newUrl)
  }

  return paramValue
}

export function removeUrlParameter (param) {
  const url = new URL(window.location.href)
  url.searchParams.delete(param)
  window.history.replaceState({}, document.title, url.toString())
}

export function getSystemPath (key) {
  const language = TWORK_SETTINGS.language || 'cs'
  const authPaths = {
    lecturer: {
      en: 'lecturer',
      cs: 'lektor',
      sk: 'lektor'
    },
    events: {
      en: 'events',
      cs: 'udalosti',
      sk: 'udalosti'
    },
    login: {
      en: 'login',
      cs: 'prihlaseni',
      sk: 'prihlasenie'
    },
    account: {
      en: 'account',
      cs: 'ucet',
      sk: 'ucet'
    },
    billingAddress: {
      en: 'billing-address',
      cs: 'fakturacni-adresa',
      sk: 'fakturacna-adresa'
    },
    certificates: {
      en: 'certificates',
      cs: 'certifikaty',
      sk: 'certifikaty'
    },
    tickets: {
      en: 'tickets',
      cs: 'vstupenky',
      sk: 'vstupenky'
    },
    legalPages: {
      en: 'legal',
      cs: 'legal',
      sk: 'legal'
    },
    partners: {
      en: 'partners',
      cs: 'partneři',
      sk: 'partneri'
    },
    vouchers: {
      en: 'vouchers',
      cs: 'vouchery',
      sk: 'vouchery'
    },
    preferences: {
      en: 'preferences',
      cs: 'preference',
      sk: 'preferencie'
    },
    payments: {
      en: 'payments',
      cs: 'platby',
      sk: 'platby'
    },
    settings: {
      en: 'settings',
      cs: 'nastaveni',
      sk: 'nastaveni'
    },
    register: {
      en: 'register',
      cs: 'registrace',
      sk: 'registracia'
    },
    forgotPassword: {
      en: 'forgot-password',
      cs: 'zapomenute-heslo',
      sk: 'zabudnute-heslo'
    },
    join: {
      en: 'join',
      cs: 'prihlaska',
      sk: 'prihlaska'
    },
    pay: {
      en: 'pay',
      cs: 'platba',
      sk: 'platba'
    },
    category: {
      en: 'category',
      cs: 'kategorie',
      sk: 'kategoria'
    },
    legal: {
      en: 'legal',
      cs: 'legal',
      sk: 'legal'
    },
    terms: {
      en: 'terms',
      cs: 'obchodni-pominky',
      sk: 'obchodni-pominky'
    },
    privacy: {
      en: 'privacy',
      cs: 'ochrana-osobnich-udaju',
      sk: 'ochrana-osobnich-udaju'
    },
    contact: {
      en: 'contact',
      cs: 'kontakt',
      sk: 'kontakt'
    },
    reviews: {
      en: 'reviews',
      cs: 'recenze',
      sk: 'recenzie'
    },
    cookiePolicy: {
      en: 'cookie-policy',
      cs: 'cookie-pravidla',
      sk: 'cookie-pravidla'
    }
  }

  // Return the path for the provided key and current language
  return authPaths[key] ? authPaths[key][language] : null
}

export function getSectionFromPath (pathSegment) {
  // Look up the reverse of getSystemPath to map back from localized segment to internal key
  const sections = {
    settings: ['settings', 'nastaveni', 'nastaveni'], // Add other languages
    certificates: ['certificates', 'certifikaty', 'certifikaty'],
    preferences: ['preferences', 'preference', 'preferencie'],
    payments: ['payments', 'platby', 'platby'],
    billingAddress: [
      'billing-address',
      'fakturacni-adresa',
      'fakturacna-adresa'
    ],
    terms: ['terms', 'podminky-uzivani', 'podminky-pouzivani'],
    privacy: ['privacy', 'ochrana-osobnich-udaju', 'ochrana-osobnych-udajov'],
    cookiePolicy: ['cookie-policy', 'cookie-pravidla', 'cookie-pravidla'],
    contact: ['contact', 'kontakt', 'kontakt']
  }

  // Iterate through sections and find the key matching the path segment
  for (const [key, translations] of Object.entries(sections)) {
    if (translations.includes(pathSegment)) {
      return key
    }
  }
  return null
}

export function findCategoryBySlug (slug) {
  // Retrieve all event types and their categories
  const eventTypes = getEventTypes()

  // Function to recursively search for the category by slug
  const searchCategories = categories => {
    for (const category of categories) {
      if (category.slug === slug) {
        return category // Return the matching category
      }
      // Recursively search in subcategories if they exist
      if (category.categories && Array.isArray(category.categories)) {
        const result = searchCategories(category.categories)
        if (result) {
          return result // Return the result from the recursive search
        }
      }
    }
    return null // Return null if no matching category is found
  }

  // Iterate over each event type's categories
  for (const eventType of eventTypes) {
    if (eventType.categories && Array.isArray(eventType.categories)) {
      const category = searchCategories(eventType.categories)
      if (category) {
        return category
      }
    }
  }

  return null // Return null if no category is found with the given slug
}

export const btnTypeText = (type, status) => {
  // Define the nested key path for each type and status
  const translationKey = `event_btn.${type}.${status}`

  // Retrieve the translated text based on the current language setting
  return translate(translationKey)
}

export const btnJoinText = (type, status) => {
  // Define the nested key path for each type and status
  const translationKey = `event_join_btn.${type}.${status}`

  // Retrieve the translated text based on the current language setting
  return translate(translationKey)
}

// Example function to format dates for display
export const formatDate = dateString => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' }
  return new Date(dateString).toLocaleDateString(undefined, options)
}

// Example function to truncate text to a specified length
export const truncateText = (text, length) => {
  return text.length > length ? text.substring(0, length) + '...' : text
}

export const statusColor = status => {
  // switch over planned,upcomming,live,ended and return tailwind color class
  switch (status) {
    case 'planned':
      return 'bg-yellow-400'
    case 'upcomming':
      return 'bg-blue-400'
    case 'live':
      return 'bg-red-400'
    case 'ended':
      return 'bg-orange-400'
    default:
      return 'bg-gray-400'
  }
}

// this function is deprecated use getStatusInfo instead!
export const statusText = status => {
  switch (status) {
    case 'planned':
      return 'Plánováno'
    case 'upcomming':
      return 'Připravujeme'
    case 'live':
      return 'Událost právě teď probíhá'
    case 'ended':
      return 'Připravujeme záznam'
    case 'playback':
      return 'Přehrajte si záznam'
    default:
      return 'Neznámý'
  }
}

export const getStatusInfo = event => {
  let finalStatus = event.status
  // Check if the event has ended
  if (event.status === 'ended') {
    const endAt = new Date(event.date.raw.end_at)
    const now = new Date()
    const oneWeekInMs = 7 * 24 * 60 * 60 * 1000
    const timeSinceEnded = now - endAt

    if (event.videos && event.videos.playback) {
      finalStatus = 'playback'
    } else if (timeSinceEnded <= oneWeekInMs) {
      finalStatus = 'awaiting_playback'
    } else {
      finalStatus = 'ended'
    }
  }

  // Map the final status to translation keys, icons, and animation classes
  switch (finalStatus) {
    case 'planned':
      return {
        text: translate('status_badge.planned'),
        bgcolor: 'bg-yellow-400',
        txtcolor: 'text-yellow-800',
        icon: ['fas', 'calendar-alt'],
        animationClass: '' // No animation
      }
    case 'upcoming':
      return {
        text: translate('status_badge.upcoming'),
        bgcolor: 'bg-blue-400',
        txtcolor: 'text-blue-800',
        icon: ['fas', 'hourglass-half'],
        animationClass: '' // No animation
      }
    case 'live':
      return {
        text: translate('status_badge.live'),
        bgcolor: 'bg-red-400',
        txtcolor: 'text-red-800',
        icon: ['fas', 'circle'],
        animationClass: 'flash-animation' // Custom animation class
      }
    case 'ended':
      return {
        text: translate('status_badge.ended'),
        bgcolor: 'bg-gray-400',
        txtcolor: 'text-gray-800',
        icon: ['fas', 'stop-circle'],
        animationClass: '' // No animation
      }
    case 'awaiting_playback':
      return {
        text: translate('status_badge.awaiting_playback'),
        bgcolor: 'bg-orange-400',
        txtcolor: 'text-orange-800',
        icon: ['fas', 'spinner'],
        animationClass: 'fa-spin' // Font Awesome's spinning class
      }
    case 'playback':
      return {
        text: translate('status_badge.playback'),
        bgcolor: 'bg-green-400',
        txtcolor: 'text-green-800',
        icon: ['fas', 'play-circle'],
        animationClass: '' // No animation
      }
    default:
      return {
        text: translate('status_badge.unknown'),
        bgcolor: 'bg-gray-400',
        txtcolor: 'text-gray-800',
        icon: ['fas', 'question-circle'],
        animationClass: '' // No animation
      }
  }
}

export function generateHashtag(name) {
  return `#${name
    .normalize("NFD")                              // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, '')                 // Remove diacritical marks
    .replace(/[^a-zA-Z0-9\s]/g, '')                  // Remove any remaining non-alphanumeric characters except spaces
    .split(/\s+/)                                  // Split by whitespace
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())  // Capitalize each word
    .join('')                                      // Join words together
    .trim()}`;                                     // Trim any leading/trailing spaces
}
export function getColorClass (eventType, shade = 500, prefix = 'text') {
  const color =
    eventType.color || window.vueAppConfig?.settings?.color || 'teal'
  return `${prefix}-${color}-${shade}`
}

export function durationFormatted (minutes) {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  let formatted = []

  if (hours > 0) {
    if (hours === 1) {
      formatted.push(`1 hodina`)
    } else if (hours > 1 && hours < 5) {
      formatted.push(`${hours} hodiny`)
    } else {
      formatted.push(`${hours} hodin`)
    }
  }

  if (mins > 0) {
    if (mins === 1) {
      formatted.push(`1 minuta`)
    } else if (mins > 1 && mins < 5) {
      formatted.push(`${mins} minuty`)
    } else {
      formatted.push(`${mins} minut`)
    }
  }

  return formatted.join(', ')
}
